import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Preload icons used for sections as defined in etc/plugin_sections.yml
/* eslint-disable no-unused-vars */
import {
  faAlignLeft,
  faCode,
  faInfoCircle,
  faMapMarkerAlt,
  faTable,
  faUsers
} from '@fortawesome/pro-solid-svg-icons';
/* eslint-enable no-unused-vars */

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

export class WebsiteSection extends React.Component {
  static propTypes = {
    ...listItemPropTypes,

    index: PropTypes.number.isRequired,
    listName: PropTypes.string.isRequired,
    section: PropTypes.shape({
      id: PropTypes.number.isRequired,
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      location: PropTypes.string.isRequired,
      sectionType: PropTypes.string.isRequired,
      customFieldSlug: PropTypes.string,
      title: PropTypes.string,
      content: PropTypes.string,
      buttonUrl: PropTypes.string,
      buttonText: PropTypes.string
    }).isRequired,
    targetGroup: PropTypes.string,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
  };

  deleteSection = () => {
    this.props.onDelete(this.props.section);
  };

  editSection = () => {
    this.props.onEdit(this.props.section);
  };

  render() {
    const listItemClass = classNames(
      'website-section',
      {
        dragging: this.props.isDragging,
        reorderable: !this.props.disabled
      }
    );
    const style = { opacity: this.props.isDragging ? 0 : 1 };
    return this.props.connectDragPreview(this.props.connectDropTarget(this.props.connectDragSource(
      <li className={listItemClass} style={style}>
        <div className="section-col section-icon text-center">
          <FontAwesomeIcon className="text-primary" icon={this.props.section.icon} name="section-icon" />
        </div>
        <div className="section-col section-label">
          <strong className="fw-semibold">{this.props.section.label}</strong>
        </div>
        <div className="section-col text-end">
          {this.renderActions()}
        </div>
      </li>
    )));
  }

  renderActions() {
    return (
      <div className="section-actions">
        <Button
          className="edit-section"
          disabled={this.props.disabled}
          name="edit-section"
          size="sm"
          variant="link"
          onClick={this.editSection}
        >
          Edit
        </Button>
        <Button
          className="text-danger delete-section"
          disabled={this.props.disabled}
          name="delete-section"
          size="sm"
          variant="link"
          onClick={this.deleteSection}
        >
          Delete
        </Button>
      </div>
    );
  }
}

export default reorderableListItem(WebsiteSection, 'websiteSection', {
  // dragSource
  canDrag: (props => !props.disabled),

  beginDrag(props) {
    return {
      id: props.section.id,
      index: props.index,
      listName: props.listName,
      targetGroup: props.targetGroup
    };
  }
});
